import { AgColumnDefinition, AgGridColumnType, AgGridExportType } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import { store } from '@/store/store'

export const billingGridCopaymentsColumnDefs =
    (): Array<AgColumnDefinition> => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            headerName: i18n.tc('accounting.field.alias'),
            field: 'alias',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            headerName: i18n.tc('accounting.field.reference'),
            field: 'referenceCode',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            headerName: i18n.tc('accounting.field.rate'),
            field: 'rate.name',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.conceptCode'),
            field: 'concept.code',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.concept'),
            field: 'concept.name',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.unit'),
            field: 'unit.symbol',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.client'),
            field: 'customer.name',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.value'),
            field: 'value',
            type: AgGridColumnType.DECIMAL,
            exportType: AgGridExportType.DOUBLE,
            minWidth: 100,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.assignmentDate'),
            field: 'creationDate',
            type: AgGridColumnType.DATETIME,
            exportType: AgGridExportType.DATETIME,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.automatic'),
            field: 'automatic',
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.authorizationRequired'),
            field: 'requiresAuthorization',
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.authorization'),
            field: 'authorizationCode',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.authorizationRequested'),
            field: 'authorizationRequested',
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.copayment'),
            field: 'isCopayment',
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            minWidth: 100,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.copaymentType'),
            field: 'copaymentType',
            type: AgGridColumnType.BILLING_COPAYMENT_TYPE,
            exportField: 'copaymentType.translatedName',
            exportType: AgGridExportType.TEXT,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.selfBilling'),
            field: 'isForAutoInvoice',
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.caseType'),
            field: 'caseStudy.caseType.description',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.error'),
            field: 'autoInvoiceSystemInError',
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.errorDescription'),
            field: 'autoInvoiceSystemErrorDescription',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 120,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.operationNumber'),
            field: 'autoInvoiceSystemOperationCode',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.caseNumber'),
            colId: 'caseStudy.casCasenumber',
            field: 'caseStudy.caseNumber',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.insurance'),
            field: 'caseStudy.insurer.name',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.insuranceDocument'),
            field: 'caseStudy.referralNumber',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.insurancePolicy'),
            field: 'caseStudy.insuranceNumber',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.regime'),
            field: 'caseStudy.regime.name',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.elementID'),
            field: 'entityLabel',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            headerName: i18n.tc('accounting.field.pathologist'),
            colId: 'caseStudy.pathologist.normalizedFullName',
            field: 'caseStudy.pathologist.fullName',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 180,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.validationDate'),
            colId: 'caseStudy.casValidationDate',
            field: 'caseStudy.validationDate',
            type: AgGridColumnType.DATETIME,
            exportType: AgGridExportType.DATETIME,
            minWidth: 100,
            suppressSizeToFit: true
        },
        {
            headerValueGetter: () => store.getters.parameters.global?.mainPatientIdentifierType.name,
            colId: 'caseStudy.patient.mainPatientIdentifier',
            field: 'caseStudy.patient.mainPatientIdentifier.paiIdentifier',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            headerValueGetter: () => store.getters.parameters.global?.secondaryPatientIdentifierType.name,
            colId: 'caseStudy.patient.secondaryPatientIdentifierType',
            field: 'caseStudy.patient.secondaryPatientIdentifierType.paiIdentifier',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            headerName: i18n.tc('global.name'),
            colId: 'caseStudy.patient.patName',
            field: 'caseStudy.patient.name',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('global.surname1'),
            colId: 'caseStudy.patient.patSurname1',
            field: 'caseStudy.patient.surname1',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('global.surname2'),
            colId: 'caseStudy.patient.patSurname2',
            field: 'caseStudy.patient.surname2',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            suppressSizeToFit: true
        }
    ]
